import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-spinner-fullscreen',
  imports: [SpinnerComponent],
  templateUrl: './spinner-fullscreen.component.html',
  styleUrl: './spinner-fullscreen.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerFullscreenComponent {}
